import { Grid2, Show } from "components";
import AdvisorIncompleteMFKYC from "Pages/AdvisorOnboarding/AdvisorIncompleteMFKYC";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";

const MFKYCVerification = () => {
  const location = useLocation();

  const [ready, setReady] = React.useState(false);

  const params = new URLSearchParams(
    location.search || location.hash.replace("#", "?"),
  );

  const token = params.get("token");
  const clientId = params.get("client_id");
  const logo = location.search.split("logo=")[1];

  useEffect(() => {
    if (!token) {
      return () => {};
    }

    const interceptor = axiosInstance.interceptors.request.use((config) => {
      console.log(token, "----2");
      config.headers.Authorization = `Token ${token}`;
      return config;
    });

    setReady(true);

    return () => {
      axiosInstance.interceptors.request.eject(interceptor);
    };
  }, [token]);

  if (!ready) {
    return <div>Setting up...</div>;
  }

  return (
    <Grid2
      container
      style={{
        width: "100vw",
        display: "flex",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--white)",
      }}
    >
      <Grid2 size={{ xs: 11, sm: 10, md: 8, lg: 6, xl: 4 }} borderRadius={3}>
        <Show.When isTrue={!!token && !!clientId && !!ready}>
          <AdvisorIncompleteMFKYC
            id={clientId}
            maxHeight={"calc(100vh - 195px)"}
            logo={logo || "https://gridkey.in/Logos/iconFullLogo.png"}
          />
        </Show.When>
      </Grid2>
    </Grid2>
  );
};

export default MFKYCVerification;
